import { useState } from "react";
import { extractTextFromPDF } from "./utils/extractTextFromPDF";
import { parseUserData } from "./utils/parseUserData";

import type { UserData } from './types'

const PDFReader: React.FC = () => {
  const [data, setData] = useState < UserData | null > (null);
  const [rawText, setRawText] = useState < string > ("");

  const handleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const text = await extractTextFromPDF(file);
    setRawText(text);

    const parsed = parseUserData(text);
    setData(parsed);
  };

  return (
    <div style={{ padding: 16 }}>
      <input
        type="file"
        accept="application/pdf"
        onChange={handleFileChange}
      />

      {data && (
        <>
          <h3>Datos detectados</h3>
          <pre>{JSON.stringify(data, null, 2)}</pre>
        </>
      )}

      {rawText && (
        <>
          <h3>Texto completo</h3>
          <textarea
            value={rawText}
            readOnly
            rows={10}
            style={{ width: "100%" }}
          />
        </>
      )}
    </div>
  );
};

export default PDFReader;
